import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryNavBarMHComponent } from './category-nav-bar.component';
import { RouterModule } from '@angular/router';
import { MyShopToggleButtonModule } from '../../my-shop/toggle-button/my-shop-toggle-button.module';

@NgModule({
  declarations: [
    CategoryNavBarMHComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MyShopToggleButtonModule,
  ],
  exports: [
    CategoryNavBarMHComponent,
  ]
})
export class CategoryNavBarMHModule { }
